<template>
    <div class="score">
        <div class="score__header">
            <div>{{ score.name }} (от {{ score.minScore }} до {{ score.maxScore }})</div>
        </div>
        <table>
            <thead>
            <tr>
                <th class="score__total">Итоговый балл</th>
                <th v-for="(expert, index) of session.reviewExperts" :key="`column${expert.id}`">Эксперт №{{ index + 1 }}</th>
            </tr>
            </thead>
            <tr>
                <td class="score__total">
                    <div v-if="readonly">{{ inputValue }}</div>
                    <input
                        v-else
                        type="text"
                        v-model="inputValue"
                        :class="{'score__total_extended': (inputValue || '').length > 4}"
                    />
                </td>
                <td v-for="expert of expertsToShow" :key="`cell${expert.id}`">
                    <div>{{ expert.score }}</div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAssessmentSuperScore",
    props: {
        score: Object,
        value: [String, Number],
        session: Object,
        readonly: Boolean,
    },
    computed: {
        expertsToShow() {
            return this.session.reviewExperts
                ? this.session.reviewExperts.reduce((result, reviewExpert) => {
                    result.push(...reviewExpert.reviewSessions.reduce((result, reviewSession) => {
                        result.push(...reviewSession.reviewSessionScores
                            .filter((reviewSessionScore) => reviewSessionScore.reviewScoreId === this.score.id)
                            .reduce((result, reviewSessionScore) => {
                                result.push({
                                    id: reviewExpert.id,
                                    score: reviewSessionScore.score,
                                });
                                return result;
                            }, []));
                        return result;
                    }, []));
                    return result;
                }, [])
                : [];
        },
        total() {
            return this.expertsToShow.reduce((result, expert) => {
                result += expert.score;
                return result;
            }, 0);
        },
    },
    watch: {
        inputValue() {
            this.$emit('input', +this.inputValue);
        },
    },
    data() {
        return {
            inputValue: this.value,
        };
    },
    mounted() {
        this.inputValue = this.value || this.total;
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.score {
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: rem(16);
  line-height: rem(24);
  color: #2A2626;
  display: flex;
  flex-direction: column;
  gap: rem(24);
  &__input {
    padding: rem(12) rem(16);
    background: #FFFFFF;
    border: rem(2) solid #4663AB;
    border-radius: rem(10);
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(30);
    color: #4663AB;
    width: rem(100);
  }
  table {
    border-spacing: 0;
    border-collapse: separate;
    th {
      border-top: solid 1px #D9D9D9;
      border-bottom: solid 1px #D9D9D9;
      padding: rem(40) 0;
    }
    td {
      text-align: center;
      padding: rem(32) 0;
      div {
        padding: rem(4) rem(16);
        background: #69609F;
        color: #FFFFFF;
        border-radius: rem(16);
        display: inline-block;
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(22);
      }
      &.score__total {
        color: #69609F;
        input, div {
          font-family: Montserrat, sans-serif;
          padding: rem(4) rem(16);
          border: 1px solid #4663AB;
          background: #FFFFFF;
          color: #2A2626;
          border-radius: rem(16);
          display: inline-block;
          font-weight: 600;
          font-size: rem(16);
          line-height: rem(22);
          text-align: center;
        }
        input {
          width: rem(80);
        }
        div {
          opacity: 0.4;

        }
        input.score__total_extended {
          width: rem(120);
        }
      }
    }
  }
  &__total {
    background: #F6FAFD;
  }
}
</style>